import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Page } from "~/components/layout/Page";

export function V2Placeholder() {
  const { t } = useTranslation();

  return (
    <Page>
      <div className="flex flex-col items-center gap-2.5 rounded-[var(--radius-md)] border border-border-default bg-white px-5 py-12 text-center">
        <Construction className="h-9 w-9 text-primary-300" />
        <div className="text-[16px] font-semibold text-fg-1">{t("feature.v2.placeholder.title")}</div>
        <div className="max-w-[420px] text-[13px] text-fg-2">{t("feature.v2.placeholder.copy")}</div>
      </div>
    </Page>
  );
}
